module.exports = __webpack_public_path__ + "img/cargo.4c40ce5f.svg";